<template>
  <div class="pt-xl-4 pt-lg-4 pt-md-4 pt-sm-4 mb-8">
    <v-card class="mx-auto py-xl-4 py-lg-4 py-md-4 py-sm-4" max-width="448" :outlined="$vuetify.breakpoint.smAndUp" :flat="$vuetify.breakpoint.xsOnly">
      <v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title class="headline mb-1">Cambiar contraseña</v-list-item-title>
          <v-list-item-subtitle>Ingrese la nueva contraseña</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-form ref="form">
        <v-card-text class="px-xl-8 px-lg-8 px-md-8 px-sm-8 px-5">
          <v-row justify="center" no-gutters>
            <v-col cols="11">
              <v-text-field
                v-model="user.password"
                label="Contraseña"
                :rules="[isRequired, minimum(6)]"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPassword ? 'text' : 'password'"
                @click:append="showPassword = !showPassword"
                autocomplete="new-password"
                filled
                dense
              ></v-text-field>
              <v-text-field
                v-model="user.newPassword"
                label="Repetir contraseña"
                :rules="[isRequired, stringsMatch(user.password, 'Las contraseñas no coinciden.')]"
                :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showNewPassword ? 'text' : 'password'"
                @click:append="showNewPassword = !showNewPassword"
                autocomplete="new-password"
                filled
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="px-xl-8 px-lg-8 px-md-8 px-sm-8 px-5 pb-6 mt-n4">
          <v-row justify="center" no-gutters>
            <v-col cols="11" class="mb-2">
              <v-btn class="text-none" block height="48" color="blue darken-1" elevation="0" :loading="loading" dark @click="update">
                Actualizar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-form>
    </v-card>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import navigationMixin from '@/mixins/navigation'
import { isRequired, minimum, stringsMatch } from '@/shared/validations'
import { getErrorMessage } from '@/shared/errors'

export default {
  mixins: [navigationMixin],
  data () {
    return {
      isRequired,
      minimum,
      stringsMatch,
      showPassword: false,
      showNewPassword: false,
      user: {
        password: '',
        newPassword: ''
      }
    }
  },
  computed: {
    ...mapState('shared', ['error', 'loading'])
  },
  methods: {
    ...mapActions('auth', ['changePassword']),
    async update () {
      if (!this.$refs.form.validate()) {
        return
      }

      const user = {
        email: this.$route.query.email,
        token: this.$route.query.token,
        password: this.user.password
      }

      await this.changePassword(user)
      if (this.error) {
        this.$emit('notificationPopup', { icon: 'error', color: 'error', message: getErrorMessage('change_password', this.error) })
        return
      }

      this.$emit('notificationPopup', { icon: 'check_circle', color: 'success', message: 'Contraseña modificada exitosamente' })
      this.goToRouteByName('Login')
    }
  }
}
</script>
<style scoped>
</style>
